import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { AnimatePresence } from 'framer-motion';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import Customers from './components/Customers';
import Widget from './components/Widget';
import Review from './components/Review';
import { CombinedProvider } from './AnimationContext';

const App: React.FC = () => {
  return (
    <CombinedProvider>
      <CssBaseline />
      <Router>
        <Layout>
          <AnimatePresence mode="wait">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/widget" element={<Widget />} />
              <Route path="/review" element={<Review />} />
            </Routes>
          </AnimatePresence>
        </Layout>
      </Router>
    </CombinedProvider>
  );
};

export default App;